var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#FF2D2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5L7.66667 12.1667L13 6.83333M5.26667 17.5H12.7333C14.2268 17.5 14.9735 17.5 15.544 17.2094C16.0457 16.9537 16.4537 16.5457 16.7094 16.044C17 15.4735 17 14.7268 17 13.2333V5.76667C17 4.27319 17 3.52646 16.7094 2.95603C16.4537 2.45426 16.0457 2.04631 15.544 1.79065C14.9735 1.5 14.2268 1.5 12.7333 1.5H5.26667C3.77319 1.5 3.02646 1.5 2.45603 1.79065C1.95426 2.04631 1.54631 2.45426 1.29065 2.95603C1 3.52646 1 4.27319 1 5.76667V13.2333C1 14.7268 1 15.4735 1.29065 16.044C1.54631 16.5457 1.95426 16.9537 2.45603 17.2094C3.02646 17.5 3.77319 17.5 5.26667 17.5Z",
    stroke: "#FFF3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckFill);
export default __webpack_public_path__ + "static/media/ic_check_fill.9f1ecd64174307efdd1debcd39c31e52.svg";
export { ForwardRef as ReactComponent };